import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, TextField, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest'
import ResumeReceivingDialog from "./ResumeReceivingDialog";
import { MenuButton, CancelButton, SubmitButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ResolvePoDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails }) {
  const [openResolve, setOpenResolve] = useState(false);
  const [loadingResolve, setLoadingResolve] = useState(false);
  const [resolutionComment, setResolutionComment] = useState("");

  const handleOpenResolve = () => {
    setResolutionComment("");
    setOpenResolve(true);
  };

  const handleCloseResolve = () => {
    if (!loadingResolve) {
        setOpenResolve(false);
    }
  };

  const resolvePo = async () => {
    setLoadingResolve(true);
    try {
        let response = await sendRequest(
            `purchase-orders/add-resolution?po_doc_id=${po_doc_id}&resolution_comment=${resolutionComment}`
        );
        addSnackbar(response.message);
        handleCloseResolve();
        fetchPoDetails();
    } catch (error) {
        addSnackbar(error.message, false);
    } finally {
        setLoadingResolve(false);
    }
  }

  const handleResolutionCommentChange = (e) => {
    let value = e.target.value;
    if (value) {
      setResolutionComment(value);
    } else {
      setResolutionComment("");
    }
  }

  return (
    <Box>
      <ResumeReceivingDialog
        po_doc_id={po_doc_id}
        poName={poName}
        addSnackbar={addSnackbar}
        fetchPoDetails={fetchPoDetails}
      />
      <MenuButton onClick={handleOpenResolve} sx={{ width: '168px'}}>Resolve & Close</MenuButton>
      <Dialog
        open={openResolve}
        onClose={handleCloseResolve}
        disableEscapeKeyDown={loadingResolve}
        PaperProps={{
          component: 'form',
          onSubmit: event => {
            event.preventDefault();
            resolvePo();
          },
          autoComplete: 'off',
        }}
      >
        <CustomDialogTitle
          header={"Resolution Comments"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>Please enter any comments about the resolution.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="resolution_comment"
            name="resolution_comment"
            label="Comments..."
            type="text"
            fullWidth
            variant="standard"
            onChange={handleResolutionCommentChange}
            multiline
            minRows={3}
          />
          <div></div>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleCloseResolve} disabled={loadingResolve}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingResolve}
            text={"Submit Resolution"}
            type="submit"
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}